import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { useToasts } from "@air/provider-toast";
import { getIsSAMLEnforced } from "@air/utils-auth";
import noop from "lodash/noop";
import { memo } from "react";
import { EmailSignUpForm } from "~/components/Auth/EmailSignUpForm";
import { useSignUpWithEmail } from "~/swr-hooks/auth/useSignUpWithEmail";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
const formID = "sign-up-with-email-modal-form";
export const SignUpModalUserDetailsForm = /*#__PURE__*/ memo((param)=>{
    let { onSuccess, accountCreationSource, email, onBackClick } = param;
    const { showToast } = useToasts();
    const { signUpWithEmail } = useSignUpWithEmail();
    return /*#__PURE__*/ _jsx(EmailSignUpForm, {
        initialValues: {
            terms: true
        },
        defaultEmail: email,
        onSubmit: async (user)=>{
            const isSamlEnforced = await getIsSAMLEnforced(user.email);
            if (isSamlEnforced) {
                showToast("You must sign in with SAML SSO for this account", {
                    timeBeforeAutoDismiss: undefined,
                    type: "assertive",
                    withCloseButton: true
                });
            } else {
                await signUpWithEmail({
                    user,
                    setFormError: (error)=>showToast(error, {
                            timeBeforeAutoDismiss: null,
                            type: "assertive",
                            withCloseButton: true
                        }),
                    onRegistrationFailure: noop,
                    onRegistrationSuccess: (account)=>{
                        onSuccess(account);
                    },
                    onUnhandledException: (error)=>{
                        reportErrorToBugsnag({
                            error,
                            context: "Error during signup",
                            metadata: {
                                Data: {
                                    email: user.email
                                }
                            }
                        });
                    },
                    creationSource: accountCreationSource
                });
            }
        },
        termsCheckbox: null,
        formID: formID,
        children: (param)=>{
            let { isSubmitting, isValid } = param;
            return /*#__PURE__*/ _jsxs("div", {
                className: "mt-12 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        isLoading: isSubmitting,
                        size: "large",
                        color: "blue",
                        disabled: !isValid || isSubmitting,
                        children: "Sign up with email"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        size: "large",
                        appearance: "ghost",
                        color: "grey",
                        disabled: isSubmitting,
                        onClick: onBackClick,
                        children: "Back"
                    })
                ]
            });
        }
    });
});
SignUpModalUserDetailsForm.displayName = "SignUpModalEmailForm";
